var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1667 13.1667V15.1517L5.99999 13.0684L1.83332 15.1517V2.33341H10.1667V3.16675H11.8333V2.33341C11.8333 1.41294 11.0871 0.666748 10.1667 0.666748H1.83332C0.912849 0.666748 0.166656 1.41294 0.166656 2.33341V17.8484L5.99999 14.9318L11.8333 17.8484V13.1667H10.1667ZM11 5.66675V7.33341H9.33332V9.00008H11V10.6667H12.6667V9.00008H14.3333V7.33341H12.6667V5.66675H11Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTag);
export default __webpack_public_path__ + "static/media/new-tag.fc02adc1382af271caccc4924c3eddb8.svg";
export { ForwardRef as ReactComponent };